import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import Table from "../../../Layout/Table/Table";
import { Navigation, NavigationMobile } from "../../Navigation/Menu";
import Menu from "../../../Layout/Menu/Menu";
import NightspotRequests from "../NightspotRequests";
import { Puff } from "react-loading-icons";
import ModalExcelHeader from "./ModalExcelHeader";
import NavBar from "../../../../components/NavBar";
import { Grid } from "../../../Layout/Grid/GridView";
import "../../Campaigns/Campaigns.css";

const ListaContactosCampanha = () => {
  const gridRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  let params = useParams();
  const [data, setData] = useState({
    list: [],
    modalExcelHeader: {
      isVisible: false,
      data: {
        rows: 0,
      },
    },
  });

  const columns = ["Nome", "Idade", "Género", "Data Registo"];
  const serializeRowsColums = () => {
    return data.list.map((item) => {
      return {
        ...item,
      };
    });
  };

  const InsideLoading = () => (
    <div className="d-flex flex-column align-items-center justify-content-center py-5">
      <Puff stroke="#6366f1" height="4em" width="4em" />
      <div className="text-muted mt-3 fw-bold">A carregar contactos...</div>
    </div>
  );

  const requestVenueContactoList = async (dataOld = {}) => {
    setIsLoading(true);
    document.title = "Contactos | Nightspot Dashboard";
    let info = await NightspotRequests.getgetVenuesContactList(params);
    if (info && info.status) {
      setData({
        ...data,
        ...dataOld,
        list: info.data.list,
      });
    }
    setIsLoading(false);
  };

  useEffect(() => {
    requestVenueContactoList();
  }, []);

  const handleFileUpload = async (event) => {
    setIsLoading(true);
    const file = event.target.files[0];
    const formData = new FormData();
    formData.append("file", file);

    let request = await NightspotRequests.uploadExcelContacts(params, formData);
    if (request && request.status) {
      setData({
        ...data,
        modalExcelHeader: {
          ...data.modalExcelHeader,
          isVisible: true,
          data: { ...data.modalExcelHeader.data, ...request.data },
        },
      });
    }
    setIsLoading(false);
  };

  const ContactsTable = () => {
    return (
      <div className="campaign-card border-0 p-3 rounded-4" style={{ background: 'rgba(255,255,255,0.03)' }}>
        <Grid
          ref={gridRef}
          rows={data.list}
          cols={[
            { hide: true, field: "id" },
            { headerName: "Nome", field: "Nome", filter: true },
            { headerName: "Email", field: "email", filter: true },
            { headerName: "Telefone", field: "Nº Telemóvel", filter: true },
            { headerName: "Idade", field: "Idade", filter: 'agNumberColumnFilter', width: 100 },
            { headerName: "Género", field: "Género", filter: true, width: 120 },
            { headerName: "Data Registo", field: "Data Registo", sort: 'desc' },
          ]}
          height="65vh"
        />
      </div>
    );
  };

  return (
    <NavBar>
      <div className="py-4 dashboard-content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/my/dashboard">
                <i className="fa-solid fa-house-chimney me-2"></i>Dashboard
              </Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/my/nightspots">Nightspots</Link>
            </li>
            <li className="breadcrumb-item active">Lista de Contactos</li>
          </ol>
        </nav>

        <div className="row mb-5 align-items-center">
          <div className="col-12 col-md-8">
            <h1 className="campaigns-section-title">Contactos</h1>
            <p className="campaigns-section-subtitle mb-0">Gere e importa a tua base de clientes para comunicares de forma eficaz.</p>
          </div>
          <div className="col-12 col-md-4 d-flex justify-content-md-end mt-3 mt-md-0">
            <div className="excel-upload-container">
              <input
                type="file"
                id="upload"
                style={{ display: "none" }}
                onChange={handleFileUpload}
                accept=".xlsx, .xls"
              />
              <label htmlFor="upload" className="btn-action btn-campaign-primary px-4 rounded-pill w-auto py-2 cursor-pointer">
                <i className="fa-solid fa-file-import me-2"></i>
                Importar Excel
              </label>
            </div>
          </div>
        </div>

        {isLoading ? (
          <InsideLoading />
        ) : (
          <div className="row">
            <div className="col-12">
              <ContactsTable />
            </div>
          </div>
        )}
        <ModalExcelHeader
          show={data.modalExcelHeader.isVisible}
          handleModalhide={(refresh = false) => {
            if (refresh) {
              requestVenueContactoList({
                modalExcelHeader: {
                  ...data.modalExcelHeader,
                  isVisible: false,
                },
              });
            } else {
              setData({
                ...data,
                modalExcelHeader: {
                  ...data.modalExcelHeader,
                  isVisible: false,
                },
              });
            }
          }}
          data={data.modalExcelHeader.data}
        />


      </div>

    </NavBar >

  );
};

export default ListaContactosCampanha;
